import React from 'react';

import { LogoStyled } from './Logo.styled';
import { RutgersLogo } from './RutgersLogo';
import { CatalystLogo } from './CatalystLogo';

export const Logo = ({ isMobile }) => {
  return (
    <LogoStyled isMobile={isMobile}>
      <RutgersLogo className='rutgersLogo'/>
      <CatalystLogo className='catalystLogo'/>
    </LogoStyled>
  )
}
